'use strict';

require('./images/Bordas.png');
require('./images/favicon.png');
require('./style.css');
require('./Orbitron-Medium.ttf');

var $ = require('jquery');

var TMSimulator = require('../TMSimulator');
var examples = require('../examples');

$(function() {
  let input = '1011';

  $('#helpModal').modal('show');
  var simulator = new TMSimulator(document.getElementById("simulator"), {
    step: document.getElementById("step"),
    run: document.getElementById("run"),
    reset: document.getElementById("reset"),
  });
  var example = examples.get(examples.firsttimeDocID);
  simulator.sourceCode = example.sourceCode;
  simulator.positionTable = example.positionTable;

  var submitSource = function(input) {
    simulator.sourceCode = example.sourceCode.replace(/input\:.*/, "input: '" + input + "'");
  }
  $('#button-input').click(function() {
    submitSource($('#input').val());
  });
  $('#input').keypress(function(e) {
    if (e.which == '13') {
        submitSource($('#input').val());
    }
  });

  $('#input').on('input', function(e) {
    let input = e.target;
    if (input.value.match(/^[0-1]*$/)) {
      $('#button-input').prop("disabled", false);
      $('#input').removeClass("is-invalid");
      $('#input-feedback').removeClass("d-block");
    } else {
      $('#button-input').prop("disabled", true);
      $('#input').addClass("is-invalid");
      $('#input-feedback').addClass("d-block");
    }
  });
});


//////////////////
// WEBPACK FOOTER
// ./src/bordas/bordas.js
// module id = 0
// module chunks = 2